import { useEffect, useState } from "react";

import useData from "../../hooks/useData";

import Modal from "./Modal";
import AutoComplete from "../elements/AutoComplete";
import Loading from "../ui/Loading";
import { Box } from "@mui/material";

const UserSelectionModal = ({
  open,
  onClose,
  onSelect,
  title = "select_user",
  filter = {},
}) => {
  const { getFromServer } = useData();

  const [users, setUsers] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    if (open) {
      loadUsers();
    }
  }, [open]);

  const loadUsers = async () => {
    try {
      const userList = await getFromServer({
        entityName: "User",
        filter: {
          isActive: true,
          ...filter,
        },
      });
      setUsers(userList);
      setSelectedUserId(null);
    } catch (error) {
      console.error("Error loading users:", error);
      setUsers([]);
    }
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    const selectedUser = users.find((user) => user.id === userId);
    if (selectedUser) {
      onSelect(selectedUser);
    }
    onClose();
  };

  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      width="450px"
      height="300px"
    >
      <Box padding="20px">
        {Array.isArray(users) ? (
          <AutoComplete
            id="user-selection"
            label="user"
            value={selectedUserId}
            items={users}
            onChange={handleUserSelect}
            width="100%"
          />
        ) : (
          <Loading />
        )}
      </Box>
    </Modal>
  );
};

export default UserSelectionModal;
